import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { compose, withHandlers, lifecycle } from "recompose";
import md5 from "md5";
import FontIcon from "react-md/lib/FontIcons";
import Button from "react-md/lib/Buttons/Button";

import TextField from "../../form/TextField";

import { setActiveForm } from "../../../actions/appActions";
import { updateUser } from "../../../actions/userActions";

const Info = ({ handleSubmit, activeForm, setActiveForm }) => (
  <div>
    {activeForm === "profilePassword" ? (
      <form className="profile-form" onSubmit={handleSubmit}>

          <div className="touchButtons-spaceAbove" />

          <Field
            component={TextField}
            componentId="profile-info-oldPassword"
            type="password"
            label="Staré heslo"
            name="oldPassword"
          />
          <Field
            component={TextField}
            componentId="profile-info-newPassword"
            type="password"
            label="Nové heslo"
            name="newPassword"
          />
          <Field
            component={TextField}
            componentId="profile-info-newPassword2"
            type="password"
            label="Potvrzení nového hesla"
            name="newPassword2"
          />

          <div className="touchButtons-spaceAbove" />

          <div className="flex-row">
            <Button
              raised
              className="btn touchButton-5"
              label="Zrušit"
              onClick={() => setActiveForm(null)}
            />
            <div className="touchButtons-spaceBetween" />
            <Button
              raised
              className="btn btn-primary touchButton-6"
              label="Uložit"
              type="submit"
            />
          </div>
      </form>
    ) : (
      <div
        className="flex-row profile-editable"
        onClick={() => setActiveForm("profilePassword")}
      >
        <p className="profile-label">Heslo:</p>
        <p>**********</p>
        <FontIcon className="edit">edit</FontIcon>
      </div>
    )}
  </div>
);

export default compose(
  connect(({ app: { form: { activeForm } } }) => ({ activeForm }), {
    setActiveForm,
    updateUser
  }),
  lifecycle({
    componentWillUnmount() {
      const { setActiveForm } = this.props;
      setActiveForm(null);
    }
  }),
  withHandlers({
    onSubmit: () => async (formData, dispatch, props) => {
      const { updateUser, user, setActiveForm } = props;
      const { oldPassword, newPassword, newPassword2 } = formData;

      if (newPassword !== newPassword2) {
        throw new SubmissionError({
          newPassword2: "Hesla nejsou totožná."
        });
      }

      if (
        await updateUser({
          ...user,
          newPassword: md5(newPassword),
          oldPassword: md5(oldPassword)
        })
      ) {
        setActiveForm(null);
      } else {
        throw new SubmissionError({
          newPassword2: "Změna hesla se nazdařila."
        });
      }
    }
  }),
  reduxForm({ form: "profilePassword" })
)(Info);



// WEBPACK FOOTER //
// ./src/components/settings/profile/Password.js